export const BREADCRUMBS = 'BREADCRUMBS';
export const DETAILS_BREADCRUMB = 'DETAILS_BREADCRUMB';
